import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./styles/styles.scss";

import Header from "./components/Header";
import Slider from "./components/Slider";
import ScrollToTop from "./components/ScrollToTop";
import { AppProvider } from "./config/ToSendProvider";
import { WhatsAppConsultaProvider } from "./config/WhatsAppConsultaContext";

const Main = lazy(() => import("./components/Main"));
const Footer = lazy(() => import("./components/Footer"));
const WhatsAppFlotante = lazy(() => import("./components/WhatsAppFlotante/WhatsAppFlotante"));
const Error404 = lazy(() => import("./components/404"));

function App() {
  return (
    <AppProvider>
      <Router basename="/montironi-jeep">
        <WhatsAppConsultaProvider>
          <ScrollToTop />
          <Switch>
            <Route exact path="/:tipo?">
              <Header />
              <Slider />
              <Suspense fallback={null}>
                <Main />
                <Footer />
                <WhatsAppFlotante />
              </Suspense>
            </Route>

            <Route path="*">
              <Suspense fallback={null}>
                <Error404 />
              </Suspense>
            </Route>
          </Switch>
        </WhatsAppConsultaProvider>
      </Router>
    </AppProvider>
  );
}

export default App;
